import { TButtonOption } from '../../../types/options';

export const getPaddingPostfix = (hasIcon: boolean, iconPosition?: TButtonOption['iconPosition'], size?: TButtonOption['size']): string => {
    switch (size) {
        case 'medium':
            return 'Medium';
        case 'small':
            if (hasIcon) {
                if (iconPosition === 'right') {
                    return 'SmallIconRight';
                }
                if (!iconPosition || iconPosition === 'left') {
                    return 'SmallIconLeft';
                }
            }
            return 'Small';
        default:
            return '';
    }
};
export const getBoxShadow = (position: TButtonOption['position'], hierarchy: TButtonOption['hierarchy'], disabled: boolean): string => {
    if (position === 'floating' && !disabled) {
        if (hierarchy === 'primary' || !hierarchy) {
            return 'Purple';
        }
        return 'Grey';
    }
    return '';
};
export const getBackground = (hierarchy: TButtonOption['hierarchy'], viewBackground: TButtonOption['viewBackground'], disabled: boolean): string => {
    switch (hierarchy) {
        case 'secondary':
            return 'white';
        case 'tertiary':
            if (viewBackground === 'gradient') {
                return 'whiteBase';
            } else {
                return 'white';
            }
        default:
            return disabled ? 'purple16Lc' : 'purple100';
    }
};
export const getColor = (hierarchy: TButtonOption['hierarchy'], viewBackground: TButtonOption['viewBackground'], disabled: boolean): string => {
    switch (hierarchy) {
        case 'secondary':
            return disabled ? 'purple_40_tr' : 'purple_100';
        case 'tertiary':
            if (viewBackground === 'gradient') {
                return 'white_base_gradient';
            } else {
                return disabled ? 'grey_40_lc' : 'black';
            }
        default:
            return disabled ? 'white_40_tr_base' : 'white_base';
    }
};
export const getContainerMarginLeft = (size: TButtonOption['size'], iconPosition: TButtonOption['iconPosition']) => {
    return size === 'small' && iconPosition === 'right' ? '4' : iconPosition === 'right' ? '8' : null;
};
export const getContainerMarginRight = (size: TButtonOption['size'], iconPosition: TButtonOption['iconPosition']) => {
    return iconPosition === 'right' ? null : size === 'small' ? '4' : '8';
};
